import { AdminDivisionsComponent } from './admin-settings/admin-divisions/admin-divisions.component';
import { AdminUsersComponent } from './admin-settings/admin-users/admin-users.component';
import { DivisionCriteriaSourceSettingsComponent } from './division-settings/division-criteria-source-settings/division-criteria-source-settings.component';
import { TemplateCriteriaDefinitionComponent } from './template-criteria/template-criteria-definition/template-criteria-definition.component';
import { DivisionScheduleComponent } from './division-settings/division-schedule/division-schedule.component';
import { DivisionSettingsComponent } from './division-settings/division-settings.component';
import { LifecycleRulesDefinitionComponent } from './lifecycle-rules/lifecycle-rules-definition/lifecycle-rules-definition.component';
import { LifecycleRulesListComponent } from './lifecycle-rules/lifecycle-rules-list/lifecycle-rules-list.component';
import { LifecycleRulesRecordSelectionComponent } from './lifecycle-rules/lifecycle-rules-record-selection/lifecycle-rules-record-selection.component';
import { LifecycleRulesComponent } from './lifecycle-rules/lifecycle-rules.component';
import { PlayDefinitionComponent } from './plays/play-definition/play-definition.component';
import { PlayRecordSelectionComponent } from './plays/play-record-selection/play-record-selection.component';
import { PlaySchedulingComponent } from './plays/play-scheduling/play-scheduling.component';
import { PlayTalkingPointsComponent } from './plays/play-talking-points/play-talking-points.component';
import { PlaysListComponent } from './plays/plays-list/plays-list.component';
import { PlaysComponent } from './plays/plays.component';
import { AdminSettingsComponent } from './admin-settings/admin-settings.component';
import { ContentLibraryComponent } from './content-library/content-library.component';
import { ReportingComponent } from './reporting/reporting.component';
import { TemplateCriteriaListComponent } from './template-criteria/template-criteria-list/template-criteria-list.component';
import { CompassRoute, CompassRouteParent, DaysOfWeek } from '@r1-compass-library/models';
import { Page } from '@r1-compass-library/components/header/header.component';
import { DivisionDataMappingComponent } from './division-settings/division-data-mapping/division-data-mapping.component';
import { SidenavLink } from '@r1-compass-library/components/sidenav/sidenav.component';
import { ContentLibraryListComponent } from './content-library/content-library-list/content-library-list.component';
import { ContentLibraryDefinitionComponent } from './content-library/content-library-definition/content-library-definition.component';
import { ContentLibraryRulesComponent } from './content-library/content-library-rules/content-library-rules.component';
import { EditRuleComponent } from './content-library/content-library-rules/edit-rule/edit-rule.component';
import { TemplateCriteriaComponent } from './template-criteria/template-criteria.component';
import { TemplateCriteriaBuilderComponent } from './template-criteria/template-criteria-builder/template-criteria-builder.component';
import { RowOptionAction, TableColumn } from '@r1-compass-library/components';
import { PlayReportingComponent } from './plays/reporting/play-reporting/play-reporting.component';
import { FileTableItemType } from '@r1-compass-library/components/file-table/file-table.model';
import { DivisionBasicSettingsComponent } from './division-settings/division-basic-settings/division-basic-settings.component';
import { DivisionSalesforceTargetsComponent } from './division-settings/division-salesforce-targets/division-salesforce-targets.component';
import { ContentLibraryEnableComponent } from './content-library/content-library-enable/content-library-enable.component';
import { TemplateCriteriaEnableComponent } from './template-criteria/template-criteria-enable/template-criteria-enable.component';
import { LifecycleRulesEnableComponent } from './lifecycle-rules/lifecycle-rules-enable/lifecycle-rules-enable.component';

export class AppConstants {
    static FILE_HEADER = 'file header';

    static readonly CONTENT_TYPE_DYNAMIC_CONTENT = 'library content';
    static readonly CONTENT_TYPE_FILE_HEADER = 'file header';
    static readonly CONTENT_TYPE_TFS = 'tfs';
    static readonly FILE_HEADER_DISPLAY_NAME = 'File Data';
    static readonly LIBRARY_CONTENT_DISPLAY_NAME = 'Library Content';

    static readonly FROALA_BASE_CLASSES = ['fr-deletable', 'field-merge', 'fr-draggable'];
    static readonly FIELD_MERGE_CLASS_FILE_HEADER = [...this.FROALA_BASE_CLASSES, 'file-header-field-merge'].join(' ');
    static readonly FIELD_MERGE_CLASS_DYNAMIC_CONTENT = [
        ...this.FROALA_BASE_CLASSES,
        'dynamic-content-field-merge',
    ].join(' ');
    static readonly FIELD_MERGE_CLASS_TFS = [...this.FROALA_BASE_CLASSES, 'tfs-field-merge'].join(' ');

    static defaultRootFolderId = 0;

    static utcOffsets = [
        '+12:00',
        '+11:00',
        '+10:00',
        '+09:00',
        '+08:00',
        '+07:00',
        '+06:00',
        '+05:00',
        '+04:00',
        '+03:00',
        '+02:00',
        '+01:00',
        '+00:00',
        '-01:00',
        '-02:00',
        '-03:00',
        '-04:00',
        '-05:00',
        '-06:00',
        '-07:00',
        '-08:00',
        '-09:00',
        '-10:00',
        '-11:00',
        '-12:00',
    ] as const;

    static days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ] as const satisfies DaysOfWeek[];

    // PLAYS
    static PlaysListComponent = {
        path: '',
        sidenavLinkTitle: 'Plays',
        containerTitle: 'Plays',
        excludeFromValidation: true,
        component: PlaysListComponent,
    } as const satisfies CompassRoute;

    static PlayDefinitionComponent = {
        path: 'definition',
        containerTitle: 'Definition',
        sidenavLinkTitle: 'Definition',
        component: PlayDefinitionComponent,
    } as const satisfies CompassRoute;

    static PlayRecordSelectionComponent = {
        path: 'record-selection',
        sidenavLinkTitle: 'Record Selection',
        containerTitle: 'Record Selection',
        sectionKey: 'recordSelection',
        component: PlayRecordSelectionComponent,
    } as const satisfies CompassRoute;

    static PlayTalkingPointsComponent = {
        path: 'talking-points',
        sidenavLinkTitle: 'Talking Points',
        containerTitle: 'Talking Points',
        sectionKey: 'talkingPoints',
        component: PlayTalkingPointsComponent,
    } as const satisfies CompassRoute;

    static PlayReportingComponent = {
        path: 'reporting',
        sidenavLinkTitle: 'Reporting',
        containerTitle: 'Reporting',
        excludeFromValidation: true,
        component: PlayReportingComponent,
    } as const satisfies CompassRoute;

    static PlaySchedulingComponent = {
        path: 'scheduling',
        sidenavLinkTitle: 'Scheduling',
        containerTitle: 'Scheduling',
        component: PlaySchedulingComponent,
    } as const satisfies CompassRoute;

    static PlaysComponent = {
        path: 'plays',
        component: PlaysComponent,
        mainTitle: 'Plays',
        children: [
            AppConstants.PlaysListComponent,
            AppConstants.PlayDefinitionComponent,
            AppConstants.PlayRecordSelectionComponent,
            AppConstants.PlayTalkingPointsComponent,
            AppConstants.PlayReportingComponent,
            AppConstants.PlaySchedulingComponent,
        ],
    } as const satisfies CompassRouteParent;

    // TEMPLATE CRITERIA
    static TemplateCriteriaDefinitionComponent = {
        path: 'definition',
        sidenavLinkTitle: 'Definition',
        containerTitle: 'Definition',
        component: TemplateCriteriaDefinitionComponent,
    } as const satisfies CompassRoute;
    static TemplateCriteriaBuilderComponent = {
        path: 'builder',
        sidenavLinkTitle: 'Record Selection',
        containerTitle: 'Record Selection',
        sectionKey: 'recordSelection',
        component: TemplateCriteriaBuilderComponent,
    } as const satisfies CompassRoute;
    static TemplateCriteriaEnableComponent = {
        path: 'enable',
        sidenavLinkTitle: 'Enable',
        containerTitle: 'Enable',
        excludeFromValidation: true,
        component: TemplateCriteriaEnableComponent,
    } as const satisfies CompassRoute;
    static TemplateCriteriaListComponent = {
        path: '',
        sidenavLinkTitle: 'Template Criteria',
        containerTitle: 'Template Criteria',
        excludeFromValidation: true,
        component: TemplateCriteriaListComponent,
    } as const satisfies CompassRoute;
    static TemplateCriteriaComponent = {
        path: 'template-criteria',
        component: TemplateCriteriaComponent,
        mainTitle: 'Template Criteria',
        children: [
            AppConstants.TemplateCriteriaDefinitionComponent,
            AppConstants.TemplateCriteriaBuilderComponent,
            AppConstants.TemplateCriteriaEnableComponent,
        ],
    } as const satisfies CompassRouteParent;

    // LIFECYCLE RULES
    static LifecycleRulesListComponent = {
        path: '',
        sidenavLinkTitle: 'Lifecycle Rules',
        containerTitle: 'Lifecycle Rules',
        excludeFromValidation: true,
        component: LifecycleRulesListComponent,
    } as const satisfies CompassRoute;

    static LifecycleRulesDefinitionComponent = {
        path: 'definition',
        sidenavLinkTitle: 'Definition',
        containerTitle: 'Definition',
        component: LifecycleRulesDefinitionComponent,
    } as const satisfies CompassRoute;

    static LifecycleRulesRecordSelectionComponent = {
        path: 'record-selection',
        sidenavLinkTitle: 'Record Selection',
        containerTitle: 'Record Selection',
        sectionKey: 'recordSelection',
        component: LifecycleRulesRecordSelectionComponent,
    } as const satisfies CompassRoute;

    static LifecycleRulesEnableComponent = {
        path: 'enable',
        sidenavLinkTitle: 'Enable',
        containerTitle: 'Enable',
        excludeFromValidation: true,
        component: LifecycleRulesEnableComponent,
    } as const satisfies CompassRoute;

    static LifecycleRulesComponent = {
        path: 'lifecycle-rules',
        component: LifecycleRulesComponent,
        mainTitle: 'Lifecycle Rules',
        children: [
            AppConstants.LifecycleRulesListComponent,
            AppConstants.LifecycleRulesDefinitionComponent,
            AppConstants.LifecycleRulesRecordSelectionComponent,
            AppConstants.LifecycleRulesEnableComponent,
        ],
    } as const satisfies CompassRouteParent;

    // CONTENT LIBRARY
    static ContentLibraryListComponent = {
        path: '',
        sidenavLinkTitle: 'Content Library',
        containerTitle: 'Talking Points Dynamic Content',
        excludeFromValidation: true,
        component: ContentLibraryListComponent,
    } as const satisfies CompassRoute;

    static ContentLibraryDefinitionComponent = {
        path: 'definition',
        sidenavLinkTitle: 'Definition',
        containerTitle: 'Definition',
        component: ContentLibraryDefinitionComponent,
    } as const satisfies CompassRoute;

    static ContentLibraryRulesComponent = {
        path: 'rules',
        sidenavLinkTitle: 'Rules',
        containerTitle: 'Rules',
        component: ContentLibraryRulesComponent,
    } as const satisfies CompassRoute;

    static ContentLibraryEnableComponent = {
        path: 'enable',
        sidenavLinkTitle: 'Enable',
        containerTitle: 'Enable',
        excludeFromValidation: true,
        component: ContentLibraryEnableComponent,
    } as const satisfies CompassRoute;

    static ContentLibraryEditRuleComponent = {
        path: 'edit-rule',
        sidenavLinkTitle: '',
        containerTitle: 'Edit Rule',
        excludeFromValidation: true,
        component: EditRuleComponent,
    } as const satisfies CompassRoute;

    static ContentLibraryComponent = {
        path: 'content-library',
        component: ContentLibraryComponent,
        mainTitle: 'Content Library',
        children: [
            AppConstants.ContentLibraryListComponent,
            AppConstants.ContentLibraryDefinitionComponent,
            AppConstants.ContentLibraryRulesComponent,
            AppConstants.ContentLibraryEnableComponent,
            AppConstants.ContentLibraryEditRuleComponent,
        ],
    } as const satisfies CompassRouteParent;

    // REPORTING
    static ReportingComponent = {
        path: 'reports',
        sidenavLinkTitle: '',
        containerTitle: '',
        excludeFromValidation: true,
        component: ReportingComponent,
    } as const satisfies CompassRoute;

    // DIVISION SETTINGS
    static DivisionBasicSettingsComponent = {
        path: 'basic-settings',
        sidenavLinkTitle: 'Basic Settings',
        containerTitle: 'Basic Settings',
        excludeFromValidation: true,
        component: DivisionBasicSettingsComponent,
    } as const satisfies CompassRoute;

    static DivisionSalesforceTargetsComponent = {
        path: 'salesforce-targets',
        sidenavLinkTitle: 'Salesforce Targets',
        containerTitle: 'Salesforce Targets',
        excludeFromValidation: true,
        component: DivisionSalesforceTargetsComponent,
    } as const satisfies CompassRoute;

    static DivisionDataMappingComponent = {
        path: 'data-mapping',
        sidenavLinkTitle: 'Data Mapping',
        containerTitle: 'Data Mapping',
        excludeFromValidation: true,
        component: DivisionDataMappingComponent,
    } as const satisfies CompassRoute;

    static DivisionCriteriaSourceSettingsComponent = {
        path: 'criteria-source-settings',
        sidenavLinkTitle: 'Criteria Source Settings',
        containerTitle: 'Criteria Source Settings',
        excludeFromValidation: true,
        component: DivisionCriteriaSourceSettingsComponent,
    } as const satisfies CompassRoute;

    static DivisionScheduleComponent = {
        path: 'schedule',
        sidenavLinkTitle: 'Schedule',
        containerTitle: 'Schedule Settings',
        excludeFromValidation: true,
        component: DivisionScheduleComponent,
    } as const satisfies CompassRoute;

    static DivisionSettingsComponent = {
        path: 'division-settings',
        component: DivisionSettingsComponent,
        mainTitle: 'Division Settings',
        children: [
            AppConstants.DivisionBasicSettingsComponent,
            AppConstants.DivisionSalesforceTargetsComponent,
            AppConstants.DivisionDataMappingComponent,
            AppConstants.DivisionCriteriaSourceSettingsComponent,
            AppConstants.DivisionScheduleComponent,
        ],
    } as const satisfies CompassRouteParent;

    // ADMIN SETTINGS
    static AdminDivisionsComponent = {
        path: 'divisions',
        sidenavLinkTitle: 'Divisions',
        containerTitle: 'Division',
        excludeFromValidation: true,
        component: AdminDivisionsComponent,
    } as const satisfies CompassRoute;

    static AdminUsersComponent = {
        path: 'users',
        sidenavLinkTitle: 'Users',
        containerTitle: 'Users',
        excludeFromValidation: true,
        component: AdminUsersComponent,
    } as const satisfies CompassRoute;

    static AdminSettingsComponent = {
        path: 'admin-settings',
        component: AdminSettingsComponent,
        mainTitle: 'Admin Settings',
        children: [AppConstants.AdminDivisionsComponent, AppConstants.AdminUsersComponent],
    } as const satisfies CompassRouteParent;

    // Header pages
    static pages: Page[] = [
        {
            name: 'Plays',
            url: `${AppConstants.PlaysComponent.path}/${AppConstants.PlaysListComponent.path}`,
            rootFolderId: `${this.defaultRootFolderId}`,
        },
        {
            name: 'Template Criteria',
            url: `${AppConstants.TemplateCriteriaComponent.path}/${AppConstants.TemplateCriteriaListComponent.path}`,
            rootFolderId: `${this.defaultRootFolderId}`,
        },
        {
            name: 'Lifecycle Rules',
            url: `${AppConstants.LifecycleRulesComponent.path}/${AppConstants.LifecycleRulesListComponent.path}`,
            rootFolderId: `${this.defaultRootFolderId}`,
        },
        {
            name: 'Content Library',
            url: `${AppConstants.ContentLibraryComponent.path}/${AppConstants.ContentLibraryListComponent.path}`,
            rootFolderId: `${this.defaultRootFolderId}`,
        },
        { name: 'Reporting', url: `${AppConstants.ReportingComponent.path}` },
        {
            name: 'Division Settings',
            url: `${AppConstants.DivisionSettingsComponent.path}/:id/${AppConstants.DivisionBasicSettingsComponent.path}`,
        },
        {
            name: 'Admin Settings',
            url: `${AppConstants.AdminSettingsComponent.path}/${AppConstants.AdminDivisionsComponent.path}`,
        },
        {
            name: 'Log Out',
            url: `login`,
        },
    ];

    // Sidenav links
    static playLinks: SidenavLink[] = [
        {
            title: AppConstants.PlayDefinitionComponent.sidenavLinkTitle,
            url: AppConstants.PlayDefinitionComponent.path,
            icon: 'gear' as const,
        },
        {
            title: AppConstants.PlayRecordSelectionComponent.sidenavLinkTitle,
            url: AppConstants.PlayRecordSelectionComponent.path,
            icon: 'database' as const,
            sectionKey: AppConstants.PlayRecordSelectionComponent.sectionKey,
        },
        {
            title: AppConstants.PlayTalkingPointsComponent.sidenavLinkTitle,
            url: AppConstants.PlayTalkingPointsComponent.path,
            icon: 'message-dollar' as const,
            sectionKey: AppConstants.PlayTalkingPointsComponent.sectionKey,
        },
        {
            title: AppConstants.PlayReportingComponent.sidenavLinkTitle,
            url: AppConstants.PlayReportingComponent.path,
            icon: 'chart-simple' as const,
        },
        {
            title: AppConstants.PlaySchedulingComponent.sidenavLinkTitle,
            url: AppConstants.PlaySchedulingComponent.path,
            icon: 'clock' as const,
        },
    ].map(link => {
        return {
            ...link,
            sectionKey: link.sectionKey ?? link.url,
            url: link.url.replace(/^/, `/${AppConstants.PlaysComponent.path}/:id/`),
        };
    });

    static lifecycleLinks: SidenavLink[] = [
        {
            title: AppConstants.LifecycleRulesDefinitionComponent.sidenavLinkTitle,
            url: AppConstants.LifecycleRulesDefinitionComponent.path,
            icon: 'gear' as const,
        },
        {
            title: AppConstants.LifecycleRulesRecordSelectionComponent.sidenavLinkTitle,
            url: AppConstants.LifecycleRulesRecordSelectionComponent.path,
            icon: 'database' as const,
            sectionKey: AppConstants.LifecycleRulesRecordSelectionComponent.sectionKey,
        },
        {
            title: AppConstants.LifecycleRulesEnableComponent.sidenavLinkTitle,
            url: AppConstants.LifecycleRulesEnableComponent.path,
            icon: 'toggle-on' as const,
        },
    ].map((link: SidenavLink) => {
        return {
            ...link,
            sectionKey: link.sectionKey ?? link.url,
            url: link.url.replace(/^/, `/${AppConstants.LifecycleRulesComponent.path}/:id/`),
        };
    });

    static divisionLinks: SidenavLink[] = [
        {
            title: AppConstants.DivisionBasicSettingsComponent.sidenavLinkTitle,
            url: AppConstants.DivisionBasicSettingsComponent.path,
            icon: 'gear' as const,
        },
        {
            title: AppConstants.DivisionSalesforceTargetsComponent.sidenavLinkTitle,
            url: AppConstants.DivisionSalesforceTargetsComponent.path,
            icon: 'salesforce' as const,
        },
        {
            title: AppConstants.DivisionDataMappingComponent.sidenavLinkTitle,
            url: AppConstants.DivisionDataMappingComponent.path,
            icon: 'diagram-project' as const,
        },
        {
            title: AppConstants.DivisionCriteriaSourceSettingsComponent.sidenavLinkTitle,
            url: AppConstants.DivisionCriteriaSourceSettingsComponent.path,
            icon: 'th-list' as const,
        },
        {
            title: AppConstants.DivisionScheduleComponent.sidenavLinkTitle,
            url: AppConstants.DivisionScheduleComponent.path,
            icon: 'clock' as const,
        },
    ];

    static templateCriteriaLinks: SidenavLink[] = [
        {
            title: AppConstants.TemplateCriteriaDefinitionComponent.sidenavLinkTitle,
            url: AppConstants.TemplateCriteriaDefinitionComponent.path,
            icon: 'gear' as const,
        },
        {
            title: AppConstants.TemplateCriteriaBuilderComponent.sidenavLinkTitle,
            url: AppConstants.TemplateCriteriaBuilderComponent.path,
            icon: 'database' as const,
            sectionKey: AppConstants.TemplateCriteriaBuilderComponent.sectionKey,
        },
        {
            title: AppConstants.TemplateCriteriaEnableComponent.sidenavLinkTitle,
            url: AppConstants.TemplateCriteriaEnableComponent.path,
            icon: 'toggle-on' as const,
        },
    ].map((link: SidenavLink) => {
        return {
            ...link,
            sectionKey: link.sectionKey ?? link.url,
            url: link.url.replace(/^/, `/${AppConstants.TemplateCriteriaComponent.path}/:id/`),
        };
    });

    static adminLinks: SidenavLink[] = [
        {
            title: AppConstants.AdminDivisionsComponent.sidenavLinkTitle,
            url: AppConstants.AdminDivisionsComponent.path,
            icon: 'sitemap' as const,
        },
        {
            title: AppConstants.AdminUsersComponent.sidenavLinkTitle,
            url: AppConstants.AdminUsersComponent.path,
            icon: 'user-unlock' as const,
        },
    ].map(link => {
        return { ...link, url: link.url.replace(/^/, `/${AppConstants.AdminSettingsComponent.path}/`) };
    });

    static contentLibraryLinks: SidenavLink[] = [
        {
            title: AppConstants.ContentLibraryDefinitionComponent.sidenavLinkTitle,
            url: AppConstants.ContentLibraryDefinitionComponent.path,
            icon: 'gear' as const,
        },
        {
            title: AppConstants.ContentLibraryRulesComponent.sidenavLinkTitle,
            url: AppConstants.ContentLibraryRulesComponent.path,
            icon: 'clipboard-list-check' as const,
        },
        {
            title: AppConstants.ContentLibraryEnableComponent.sidenavLinkTitle,
            url: AppConstants.ContentLibraryEnableComponent.path,
            icon: 'toggle-on' as const,
        },
    ].map((link: SidenavLink) => {
        return {
            ...link,
            sectionKey: link.sectionKey ?? link.url,
            url: link.url.replace(/^/, `/${AppConstants.ContentLibraryComponent.path}/:id/`),
        };
    });

    static readonly folderNavColumns: TableColumn[] = [
        {
            columnDef: 'id',
            header: 'ID',
            type: 'number',
        },
        {
            columnDef: 'name',
            header: 'Name',
            type: 'string',
        },
        {
            columnDef: 'description',
            header: 'Description',
            type: 'string',
        },
        {
            columnDef: 'updatedAt',
            header: 'Last Modified At',
            type: 'date',
        },
        {
            columnDef: 'updatedByUsername',
            header: 'Last Modified By',
            type: 'string',
        },
        {
            columnDef: 'createdAt',
            header: 'Created At',
            type: 'date',
        },
        {
            columnDef: 'createdByUsername',
            header: 'Created By',
            type: 'string',
        },
        {
            columnDef: 'action',
            header: 'Action',
            type: 'action',
        },
    ];

    static folderNavColumnsForPlays: TableColumn[] = (() => {
        const columns = [...this.folderNavColumns];
        const depCount: TableColumn = {
            columnDef: 'enabled',
            header: 'Status',
            type: 'boolean',
        };
        columns.splice(3, 0, depCount);
        return columns;
    })();

    static folderNavColumnsWithDependencies: TableColumn[] = (() => {
        const columns = [...this.folderNavColumns];
        const depCount: TableColumn = {
            columnDef: 'dependencyCount',
            header: 'Dependencies',
            type: 'dependencyCount',
        };
        columns.splice(2, 0, depCount);
        return columns;
    })();

    static folderNameColumnsForAssets: TableColumn[] = (() => {
        const columns = [...this.folderNavColumnsWithDependencies];
        const enabled: TableColumn = {
            columnDef: 'enabled',
            header: 'Status',
            type: 'boolean',
        };
        columns.splice(3, 0, enabled);
        return columns;
    })();

    static defaultRowOptionActions: { [key in FileTableItemType]: RowOptionAction[] } = {
        asset: [
            { value: 'move', display: 'Move' },
            { value: 'delete', display: 'Delete' },
            { value: 'copy', display: 'Copy' },
        ],
        folder: [
            { value: 'edit', display: 'Edit' },
            { value: 'move', display: 'Move' },
        ],
    };
}
